'use client';
import { useState, useCallback } from 'react';

function useDisclosure(initialState, callbacks) {
    if (initialState === void 0) initialState = false;
    var _ref = callbacks || {}, onOpen = _ref.onOpen, onClose = _ref.onClose;
    var _useState = useState(initialState), opened = _useState[0], setOpened = _useState[1];
    var open = useCallback(function() {
        setOpened(function(isOpened) {
            if (!isOpened) {
                onOpen == null ? void 0 : onOpen();
                return true;
            }
            return isOpened;
        });
    }, [
        onOpen
    ]);
    var close = useCallback(function() {
        setOpened(function(isOpened) {
            if (isOpened) {
                onClose == null ? void 0 : onClose();
                return false;
            }
            return isOpened;
        });
    }, [
        onClose
    ]);
    var toggle = useCallback(function() {
        opened ? close() : open();
    }, [
        close,
        open,
        opened
    ]);
    return [
        opened,
        {
            open: open,
            close: close,
            toggle: toggle
        }
    ];
}

export { useDisclosure };
